module.exports = __webpack_public_path__ + "static/media/save.fcb7a012.svg";